/**
 * Lightweight logger.
 * - In dev/preview (`REACT_APP_ENV !== "production"`): always logs.
 * - In production builds: only warn + error are forwarded.
 *
 * Usage:
 *   import { log } from "../utils/logger";
 *   log.debug("[Module] payload", payload);
 *   log.warn("[Module] failed to fetch", err);
 *   log.error("[Module] critical", err);
 *
 * This file exists so future code can use a single import and we can
 * silence noise in production by flipping one constant.
 */
const IS_PROD = process.env.NODE_ENV === "production" &&
                process.env.REACT_APP_ENV === "production";

export const log = {
  debug: (...args) => { if (!IS_PROD) console.log(...args); },
  info:  (...args) => { if (!IS_PROD) console.info(...args); },
  warn:  (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default log;
